import type { DatesType, DateType } from '../utils';

export enum SOURCE {
  OSE_RESULTS_ABBA = 'ose_results_abba',
  CSW = 'csw',
  BANNER = 'banner',
  PODS = 'pods',
  PODS_TSX = 'pods_tsx',
  WIDGET_TSX_INDEX = 'widget_tsx_index',
  WIDGET_TSX_MAP = 'widget_tsx_map',
}

type RoomData = {
  adults: number;
  ages: number[];
};

export type PeopleData = RoomData[];

export type WidgetDataDates = {
  departureDate: {
    type: DateType;
  };
  returnDate: {
    type: DateType;
  };
  flexDate: {
    daysfrom: number;
    daysto: number;
    subType: DateType;
    type: DateType;
  };
  subDate: number;
  type: DatesType;
};
